import React from "react"
import useCartCookie from "../../../hooks/use-cart-cookie.hook"
import ShoppingCartIcon from "../../../images/icons/cart.inline.svg"
import ShoppingCartIconWhite from "../../../images/icons/cart-white.inline.svg"
import { MagentoPath } from "../../../navigation/constants/routes"
import { AppFunctionComponent } from "../../../types"
import { NeutralRawLink } from "../../../ui/components/link/link.component"
import { Notification } from "../../common/general-styles.component"

const CartIcon: AppFunctionComponent = ({ className, isDark }) => {
  const { cartData } = useCartCookie()

  return (
    <NeutralRawLink
      to={MagentoPath.Cart}
      className={className}
      aria-label={"Cart"}
    >
      {isDark ? (
        <ShoppingCartIconWhite aria-hidden="true" />
      ) : (
        <ShoppingCartIcon aria-hidden="true" />
      )}
      {cartData && cartData.item_qty > 0 ? (
        <Notification data-testid="cart-notification">
          {cartData.item_qty}
        </Notification>
      ) : null}
    </NeutralRawLink>
  )
}

export default CartIcon
